import { apiClient } from "./ApiClient";

export const startUserVmAPI = (payload) =>
  apiClient
    .post("/manageUserVms", payload)   // same endpoint
    .then((res) => res.data);

export const getUserVmStatusAPI = (payload) =>
  apiClient
    .post("/manageUserVms", payload)   // UPDATED endpoint
    .then((res) => res.data);
